<template>
  <div>
    <page-title>Port User Profile</page-title>
    <change-password></change-password>
  </div>
</template>

<script>
import ChangePassword from "@/modules/commonModule/components/changePassword/Main";
export default {
  name: "AdminUserProfile",

  components: { ChangePassword },

  data() {
    return {};
  }
};
</script>
<style scoped="">
</style>
